import * as React from 'react'
import { Button } from 'react-bootstrap';

export const CustomButton = ({ text, type, show, className, ...htmlProps }: ButtonProps): JSX.Element => {

    return show ? (<Button className={className ? "btn btn-default medium margin-top margin-bottom " + className : "btn btn-default cyan-btn medium margin-top margin-bottom"} type={
        type || 'button'} {...htmlProps}>
        {text}
    </Button>) : null;

}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string,
    show: boolean,
    className?: string
}
